<!-- 业务商品列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <firstGoodsAction v-if="showStatus" ref="firstGoodsAction" @drawerCancel="drawerCancel" :actionData="actionData">
            </firstGoodsAction>
        </el-drawer>

        <el-drawer :close-on-press-escape="true" :visible.sync="showStatusPrice" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <businessGoodsPrice v-if="showStatusPrice" ref="businessGoodsPrice" @priceDrawerCancel="priceDrawerCancel" :bgPriceActionData="bgPriceActionData"></businessGoodsPrice>
        </el-drawer>

        <el-drawer :close-on-press-escape="true" :visible.sync="showStatusTax" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <businessGoodsTax v-if="showStatusTax" ref="businessGoodsTax" @taxDrawerCancel="taxDrawerCancel" :bgTaxActionData="bgTaxActionData"></businessGoodsTax>
        </el-drawer>

        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" :flagList="['bgiCurtype','categoryCode']" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-select clearable size="mini" v-if="formOneValue.entityField == 'bgiCurtype'" v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
                            <el-option v-for="item in bgiCurtypeList" :key="item.diValue" :label="item.diName" :value="item.diValue">
                            </el-option>
                        </el-select>
                        <el-cascader v-if="formOneValue.entityField == 'categoryCode'" ref="elCascader" :show-all-levels="false" :props="{ emitPath: false,checkStrictly:true }" v-model="getRequestData[formOneValue.entityField]"
                            :options="categoryList" filterable></el-cascader>
                    </template>
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <div class="left" :style="{height: tableHeight+'px'}" v-if="isMenu">
                <el-menu :default-active="activeMenu" :key="'menu-' + menuList.length" class="el-menu-vertical-demo" @select="handleMenuSelect">
                    <el-menu-item index="all">
                        <i class="el-icon-menu"></i>
                        <span slot="title">全部</span>
                    </el-menu-item>
                    <el-menu-item v-for="item in menuList" :key="item.codeId" :index="String(item.codeId)">
                        <i class="el-icon-document"></i>
                        <span slot="title">{{ item.codeType }}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="right" :class="{ 'right-full': !isMenu }">
                <el-table :row-class-name="rowClassName" v-if="pageShowData.jurTableVo" :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini"
                    @sort-change="sortChange">
                    <el-table-column label="选择操作" align="center" width="80">
                        <template slot-scope="scope">
                            <el-radio v-model="selectedDataIndex" :label="scope.row.index" border size="mini">
                                <i class="el-icon-thumb"></i>
                            </el-radio>
                        </template>
                    </el-table-column>
                    <!-- 主信息 -->
                    <el-table-column v-if="tableValye.isShow == 1" align="center" :sortable="tableValye.isSort == 1 ? 'custom' : false" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
                        :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip :min-width="tableValye.fieldWeight">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                            </span>
                            <span v-else-if="tableValye.entityField == 'bgmActivestatus'">
                                {{ $store.state.businessGoodsState[scope.row.bgmActivestatus].name }}
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog v-if="statusFlag" title="修改状态" :visible.sync="statusFlag" append-to-body top="20%" width="600px">
            <el-form @submit.native.prevent size="mini" :show-message="false" :model="statusSendData" ref="statusSendData" label-width="100px">
                <el-form-item label="状态" prop="bgmActivestatus" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-select v-model="statusSendData.bgmActivestatus" size="mini" clearable>
                        <el-option label="停用" :value="0"></el-option>
                        <el-option label="正常" :value="1"></el-option>
                        <el-option label="停止采购" :value="2"></el-option>
                        <el-option label="停止销售" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="bgmRemarks">
                    <el-input v-model.trim="statusSendData.bgmRemarks" type="textarea" size="mini" clearable :maxlength="$store.state.inputLength"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="statusFlag = false">取 消</el-button>
                <el-button type="primary" @click="sendDataAction('statusSendData')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog v-if="goodsLockState" title="商品锁定状态" :visible.sync="goodsLockState" append-to-body top="10%" width="600px">
            <el-form @submit.native.prevent size="mini" :model="lockSendDate" :show-message="false" ref="lockSendDate" label-width="100px">
                <!-- <el-form-item  label="状态" prop="activestatus" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
          <el-select v-model="lockSendDate.activestatus" size="mini" clearable :disabled="true">
            <el-option label="锁定" :value="0"></el-option>
            <el-option label="解锁" :value="1"></el-option>
          </el-select>
        </el-form-item> -->
                <el-form-item label="原因" prop="bgmRemarks" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-input v-model.trim="lockSendDate.bgmRemarks" type="textarea" size="mini" clearable :maxlength="$store.state.inputLength"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="statusFlag = false">取 消</el-button>
                <el-button type="primary" @click="lockSendAction('lockSendDate')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <div class="bgmObj" v-if="bgmShow">
                <p v-if="bgmCodeObj.bgmName">
                    <span>通用名称:</span>
                    <span>{{ bgmCodeObj.bgmName }}</span>
                </p>
                <p v-if="bgmCodeObj.bgiGename">
                    <span>商品名称:</span>
                    <span>{{ bgmCodeObj.bgiGename }}</span>
                </p>
                <p v-if="bgmCodeObj.bgmCode">
                    <span>商品编号:</span>
                    <span>{{ bgmCodeObj.bgmCode }}</span>
                </p>
                <p v-if="bgmCodeObj.spec">
                    <span>规格:</span>
                    <span>{{ bgmCodeObj.spec }}</span>
                </p>
                <p v-if="bgmCodeObj.manufacturer">
                    <span>生产商:</span>
                    <span>{{ bgmCodeObj.manufacturer }}</span>
                </p>
                <p v-if="bgmCodeObj.bgiAppnumber">
                    <span>批准文号:</span>
                    <span>{{ bgmCodeObj.bgiAppnumber }}</span>
                </p>
                <p v-if="bgmCodeObj.spId">
                    <span>编码:</span>
                    <span>{{ bgmCodeObj.spId }}</span>
                </p>
            </div>
            <SearchScheme :oneFlag="oneFlag" ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <!-- DI码维护 -->
        <el-dialog title="DI码维护" :visible.sync="DIShow" width="500px" :modal-append-to-body='true' :append-to-body="true" class="dialogBox2">
            <el-form label-width="80px" inline @submit.native.prevent>
                <el-form-item label="DI码" prop="diCode">
                    <el-input class="input_rule" v-model="diCode" @keyup.enter.native="DInative()"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="DInative">添加</el-button>
                </el-form-item>
            </el-form>
            <u-table ref="plTable" :data="DIlist" use-virtual showBodyOverflow="title" :height="400" showHeaderOverflow="title" :row-height="30" border>
                <u-table-column label="序号" type="index" width="100" />
                <u-table-column :resizable="true" show-overflow-tooltip prop="diCode" label="DI码" min-width="120" />
                <u-table-column :resizable="true" show-overflow-tooltip prop="type" label="状态" min-width="120">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="delDIClick(scope.$index)">删除</el-button>
                    </template>
                </u-table-column>
            </u-table>
            <div class="floor">
                <el-button type="primary" @click="onDI">保 存</el-button>
            </div>
        </el-dialog>
        <el-dialog v-if="bgmCodeShow" title="维护编码" :visible.sync="bgmCodeShow" append-to-body top="30px" width="600px">
            <el-form @submit.native.prevent size="mini" :model="bgmCodeObj" :show-message="false" ref="bgmCodeObj" label-width="100px">
                <el-form-item label="通用名称" prop="bgmName">
                    <el-input v-model.trim="bgmCodeObj.bgmName" type="text" size="mini" readonly></el-input>
                </el-form-item>
                <el-form-item label="商品名称" prop="bgiGename">
                    <el-input v-model.trim="bgmCodeObj.bgiGename" type="text" size="mini" readonly></el-input>
                </el-form-item>
                <el-form-item label="商品编号" prop="bgmCode">
                    <el-input v-model.trim="bgmCodeObj.bgmCode" type="text" size="mini" readonly></el-input>
                </el-form-item>
                <el-form-item label="规格" prop="spec">
                    <el-input v-model.trim="bgmCodeObj.spec" type="text" size="mini" readonly></el-input>
                </el-form-item>
                <el-form-item label="生产商" prop="manufacturer">
                    <el-input v-model.trim="bgmCodeObj.manufacturer" type="text" size="mini" readonly></el-input>
                </el-form-item>
                <el-form-item label="批准文号" prop="bgiAppnumber">
                    <el-input v-model.trim="bgmCodeObj.bgiAppnumber" type="text" size="mini" readonly></el-input>
                </el-form-item>
                <el-form-item label="编码" prop="spId" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-input clearable @clear="clear('spId')" v-model="bgmCodeObj.spId" @keyup.enter.native="openSearch(1453804425216, 0, 'bgmName', 'spId')">
                        <el-button @click="openSearch(1453804425216, 0, 'bgmName', 'spId')" slot="append" icon="el-icon-search">
                        </el-button>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="bgmCodeShow = false">取 消</el-button>
                <el-button type="primary" @click="bgmCodeSubmit('bgmCodeObj')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="更新注册证" v-if="bgiRegistnoShow" :visible.sync="bgiRegistnoShow" width="1000px" :modal-append-to-body='true' :append-to-body="true">
            <el-form inline @submit.native.prevent size="mini" :model="bgiRegistnoObj" :show-message="false" ref="bgiRegistnoObj" label-width="100px">
                <el-form-item label="旧注册证号" prop="oldBgiRegistno" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-input style="width: 200px" clearable @clear="clear('oldBgiRegistno,oldRegistnoId')" v-model="bgiRegistnoObj.oldBgiRegistno" @keyup.enter.native="openSearch(0, 0, 'oldBgiRegistno')">
                        <el-button @click="openSearch(0, 0, 'oldBgiRegistno')" slot="append" icon="el-icon-search">
                        </el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="旧注册证名称" prop="oldBgiRegistname">
                    <el-input style="width: 200px" v-model="bgiRegistnoObj.oldBgiRegistname" readonly></el-input>
                </el-form-item>
                <el-form-item label="旧注册证效期" prop="oldGlTervalidity">
                    <el-input style="width: 200px" v-model="bgiRegistnoObj.oldGlTervalidity" readonly></el-input>
                </el-form-item>
                <el-form-item label="新注册证号" prop="newBgiRegistno" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-input style="width: 200px" clearable @clear="clear('newBgiRegistno,newRegistnoId')" v-model="bgiRegistnoObj.newBgiRegistno" @keyup.enter.native="openSearch(0, 0, 'newBgiRegistno')">
                        <el-button @click="openSearch(0, 0, 'newBgiRegistno')" slot="append" icon="el-icon-search">
                        </el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="新注册证名称" prop="newBgiRegistname">
                    <el-input style="width: 200px" v-model="bgiRegistnoObj.newBgiRegistname" readonly></el-input>
                </el-form-item>
                <el-form-item label="新注册证效期" prop="newGlTervalidity">
                    <el-input style="width: 200px" v-model="bgiRegistnoObj.newGlTervalidity" readonly></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="bgiRegistnoShow = false">取 消</el-button>
                <el-button type="primary" @click="bgiRegistnoSubmit('bgiRegistnoObj')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="seTitle" v-if="instrumentFlag" :visible.sync="instrumentFlag" width="70%" :modal-append-to-body='true' :append-to-body="true" top="20px">
            <bgiRegistnoAction ref="bgiRegistnoAction" @TranData="bgiBrandClick">
            </bgiRegistnoAction>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import SearchScheme from "../../byComponents/SearchScheme.vue"
import businessGoodsPrice from "@/components/businessGoodsPrice.vue";
import firstGoodsAction from "@/components/firstGoodsAction.vue";
import businessGoodsTax from "@/components/businessGoodsTax.vue";
import bgiRegistnoAction from "@/components/bgiRegistnoAction.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        businessGoodsPrice,
        firstGoodsAction,
        businessGoodsTax,
        bgiRegistnoAction
    },
    data() {
        //这里存放数据
        return {
            closeFlag: true,
            productClassify: 5,
            classifyList: [
                {
                    label: "商品分类",
                    value: 5,
                    children: [],
                },
                {
                    label: "类别",
                    value: 1,
                    children: [],
                },
                {
                    label: "剂型",
                    value: 0,
                    children: [],
                }, {
                    label: "税务分类",
                    value: 14,
                    children: [],
                },
            ],
            filterText: "",
            treeList: [],
            tableWidth: 500,
            requesUrl: '',
            ormId: "",
            tableHeight: 0,
            getRequestData: {
                bgmId: "",
                bgmName: "",
                page: 1,
                rows: 30,
                stName: "",
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            selectedDataIndex: 0,
            pageShowData: [],
            formDataList: [],
            imgUrl: '', //图片显示根路径
            showStatus: false,
            showStatusPrice: false,
            showStatusTax: false,
            actionData: {},
            bgPriceActionData: {}, //调价
            bgTaxActionData: {}, //调税
            statusFlag: false,
            goodsLockState: false,
            statusSendData: {
                bgmActivestatus: '', //	商品状态
                bgmRemarks: '', //	备注
                id: '', //	
            },
            lockSendDate: {
                bgmId: "",
                activestatus: "",
                bgmRemarks: ""
            },
            DialogVisible: false,
            seId: "",
            sField: "",
            cmId: "",
            parentSearchData: {},
            seWidth: 0,
            seTitle: "",
            seType: "",
            bgiCurtypeList: [],//养护类型字典
            //--------------------------------------------
            DIShow: false,
            diCode: "",
            bgmId: "",
            DIlist: [],
            //------------------
            bgmCodeShow: false,
            bgmCodeObj: {
                bgmCode: "",
                bgiGename: "",
                bgmName: "",
                bgmId: "",
                spec: "",
                manufacturer: "",
                spId: "",
                bgiAppnumber: "",
            },
            bgmShow: false,
            oneFlag: false,
            //--------------------更新注册证
            bgiRegistnoShow: false,
            bgiRegistnoObj: {
                newRegistnoId: "",//新注册证号ID
                newBgiRegistno: "",//新注册证号
                newBgiRegistname: "",//新注册证名称
                newGlTervalidity: "",//新注册证效期
                oldRegistnoId: "",//旧注册证号ID
                oldBgiRegistno: "",//旧注册证号
                oldBgiRegistname: "",//旧注册证名称
                oldGlTervalidity: "",//旧注册证效期
            },
            instrumentFlag: false,
            categoryList: [],
            menuList: [],
            activeMenu: "all",
            isMenu: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
        "getRequestData.bgmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.bgmId = "";
                }
            },
            deep: true,
        },
        "getRequestData.stName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.stId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = ""
            if (row.focuson == 1) {
                rowName = "danger-row"; // 可以通过此处给选中行一个class，给自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        //获取分类
        async categoryquery() {
            let responseData = await this.$http.categoryquery({});
            if (responseData.status == 200) {
                this.categoryList = []
                if (responseData.result.length > 0) {
                    this.categoryList = this.handleJurisdiction(responseData.result)
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 权限处理
        handleJurisdiction(data, id = 0, lev = 0) {
            var son = []
            data.forEach((value, keys) => {
                if (value['parentId'] == id) {
                    value = { ...value }
                    value['id'] = value['id']
                    value['value'] = value['pathCode']
                    value['label'] = value['categoryName']
                    var list = this.handleJurisdiction(data, value['id'], lev + 1);
                    if (list.length >= 1) {
                        value['children'] = this.handleJurisdiction(data, value['id'], lev + 1);
                    }
                    son.push(value)

                }
            })
            return son;
        },
        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [10],
            });
            if (responseData.status == 200) {
                this.bgiCurtypeList = responseData.result.yhlx;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        selectChange() {
            var arr = this.classifyList.filter(val => val.value == this.productClassify)
            if (arr.length > 0) {
                this.treeList = arr[0].children
            }
            console.log(this.treeList);

            // this.selectInit()
        },
        sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.seType = type
            if (type == 'oldBgiRegistno' || type == 'newBgiRegistno') {
                this.instrumentFlag = true
                return
            }
            this.bgmShow = false
            this.oneFlag = false
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            if (sField == 'spId') {
                this.bgmShow = true
                this.oneFlag = true
                this.parentSearchData[type] = this.bgmCodeObj[type]
            } else {
                this.parentSearchData[type] = this.getRequestData[type]
            }

        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.sField == 'spId') {
                    this.bgmCodeObj.spId = val.spId
                } else {
                    this.paramValue(val)
                }
            }
        },
        bgiBrandClick(val) {
            if (this.seType == 'oldBgiRegistno') {
                this.bgiRegistnoObj.oldRegistnoId = val.row.regId
                this.bgiRegistnoObj.oldBgiRegistno = val.row.bgiRegistno
                this.bgiRegistnoObj.oldBgiRegistname = val.row.bgiRegistname
                this.bgiRegistnoObj.oldGlTervalidity = this.$common.getLocalTime(val.row.glTervalidity)
            } else if (this.seType == 'newBgiRegistno') {
                this.bgiRegistnoObj.newRegistnoId = val.row.regId
                this.bgiRegistnoObj.newBgiRegistno = val.row.bgiRegistno
                this.bgiRegistnoObj.newBgiRegistname = val.row.bgiRegistname
                this.bgiRegistnoObj.newGlTervalidity = this.$common.getLocalTime(val.row.glTervalidity)
            }
            this.instrumentFlag = false
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },

        //弹窗关闭
        drawerCancel() {
            this.showStatus = false
            this.getDataList()
        },
        priceDrawerCancel(commitData) {
            this.showStatusPrice = false
            commitData && this.getDataList()
        },
        taxDrawerCancel(commitData) {
            this.showStatusTax = false
            commitData && this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },
        //图片地址转换
        pictureShow(data) {
            var imgList = [];
            data.forEach((item) => {
                imgList.push(this.imgUrl + '/' + item.fileUrl);
            });
            return imgList;
        },
        isShowData(name, value) {
            switch (name) {
                case "bgmId":
                    var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.bgmId = dataInfo.bgmId;
                        this.getRequestData.bgmName = dataInfo.bgmName;
                    }
                    break;

                default:
                    this.getRequestData[name] = value;
            }
        },
        getPageInfo() {
            var ss = parent.getMenuInfo(this.$route.path);
            this.getDataTest(ss.jurId);
            this.productClassify = 5
            this.categoryquery()
        },

        // 获取数据列表
        async getDataTest(ids) {
            let responseData = await this.$http.getJur({
                ids: [ids]
            });
            if (responseData.status == 200) {
                this.getButtonList()
                this.pageShowData = responseData.result;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.$nextTick(async () => {
                    //商品分类
                    var arr1 = []
                    this.pageShowData.jurFormVoList.forEach(item => {
                        var arr
                        if (item.jciId == 11145 || item.jciId == 1077687) {
                            arr = item.jurconfigform.filter(val => val.entityField == 'bgiType')
                            if (arr.length > 0) {
                                if (arr[0].formatterContent != null) {
                                    arr1.push(...JSON.parse(arr[0].formatterContent))
                                }
                            }
                        }
                    })
                    arr1.forEach(item => {
                        this.$set(item, 'label', item.key)
                    })
                    this.classifyList.forEach(item => {
                        if (item.value === 5) {
                            this.$set(item, "children", arr1);
                        }
                    })
                    this.treeList = arr1
                    //剂型
                    await this.getQueryScopeByType(0).then((res) => {
                        this.classifyList.forEach(item => {
                            if (item.value === 0) {
                                this.$set(item, "children", res);
                            }
                        })
                    });
                    //类别
                    await this.getQueryScopeByType(1).then((res) => {
                        this.classifyList.forEach(item => {
                            if (item.value === 1) {
                                this.$set(item, "children", res);
                            }
                        })
                    });
                    //税务分类
                    await this.getCateDictionariesData(14).then((res) => {
                        this.classifyList.forEach(item => {
                            if (item.value === 14) {
                                this.$set(item, "children", res);
                            }
                        })
                    });
                    await this.getMenuData()
                    this.getDataList();
                    this.getPartDictionariesData()
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getCateDictionariesData(type) {
            let responseData = await this.$http.getCateDictionariesData({ ids: [type] });
            if (responseData.status == 200) {
                var list = []
                responseData.result.forEach(item => {
                    list.push({
                        label: item.diName,
                        value: item.diValue,
                    })
                })
                return list;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取生产/经营范围
        async getQueryScopeByType(type) {
            let ormId = sessionStorage.getItem("ormId");
            let params = {
                type: type,
                ormId: ormId,
            };
            //type 范围类型0.生产范围1.经营范围
            let responseData = await this.$http.queryScopeByTypeByOrm(params);
            if (responseData.status == 200) {
                var list = []
                responseData.result.forEach(item => {
                    list.push({
                        label: item.scopeName,
                        value: item.scopeName,//discId
                    })
                })
                return list;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType);
            this.formDataList = []
            switch (actionData.actionType) {
                case 0: //商品
                    this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                        if (!(/(器|其他)/g.test(v.jciName))) this.formDataList.push(v)
                    })
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: '',
                        fatherType: true
                    }
                    this.showStatus = true
                    break;
                case 1:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];

                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    let data
                    this.$http.getBusinessGoodsDetails({
                        ids: [dataInfo.bgmId]
                    }).then(res => {
                        if (res.status == 200) {
                            data = res.result
                            if (dataInfo.goodType == 1) { //药品类型0.药品1.器械
                                this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                                    if (!(/(商品|其他)/g.test(v.jciName))) this.formDataList.push(v)
                                })
                                this.actionData = {
                                    cate: 1,
                                    formData: this.formDataList,
                                    oldData: data,
                                    orderId: data.bgmId,
                                    printSouce: '',
                                    printJurId: '',
                                    fatherType: true
                                }
                            } else if (dataInfo.goodType == 0) {
                                this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                                    // console.log(v.jciName, /(器)/g.test(v.jciName));
                                    if (!(/(器|其他)/g.test(v.jciName))) this.formDataList.push(v)
                                })
                                this.actionData = {
                                    cate: 1,
                                    formData: this.formDataList,
                                    oldData: data,
                                    orderId: data.bgmId,
                                    printSouce: '',
                                    printJurId: '',
                                    fatherType: true
                                }
                            }
                            else {
                                this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                                    // console.log(v.jciName, /(器)/g.test(v.jciName));
                                    if (!(/(器|商品)/g.test(v.jciName))) this.formDataList.push(v)
                                })
                                this.actionData = {
                                    cate: 1,
                                    formData: this.formDataList,
                                    oldData: data,
                                    orderId: data.bgmId,
                                    printSouce: '',
                                    printJurId: '',
                                    fatherType: true
                                }
                            }
                            this.showStatus = true
                        }
                    })

                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 3:
                    this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                        this.formDataList.push(v)
                    })
                    var dataInfo = this.returnData.list[this.selectedDataIndex];

                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    console.log(this.formDataList, "测试");
                    let formData = this.formDataList.filter(item => item.jciId == 11149)
                    this.$http.getBusinessGoodsDetails({
                        ids: [dataInfo.bgmId]
                    }).then(res => {
                        console.log(res);
                        if (res.status == 200) {
                            this.bgPriceActionData = {
                                cate: 3,
                                formData: formData.length > 0 ? formData[0] : [],
                                oldData: res.result,
                                orderId: dataInfo.bgmId,
                                printSouce: '',
                                printJurId: '',
                                fatherType: true
                            }
                            this.showStatusPrice = true
                        }
                    })

                    break;
                case 4:
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.showStatusTax = true
                    this.bgTaxActionData = {
                        cate: 4,
                        formData: '',
                        oldData: dataInfo,
                        orderId: dataInfo.bgmId,
                        printSouce: '',
                        printJurId: '',
                        fatherType: true
                    }
                    break;
                case 5: //器械
                    this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                        if (!(/(商品|其他)/g.test(v.jciName))) this.formDataList.push(v)
                    })
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: '',
                        fatherType: true
                    }
                    this.showStatus = true
                    break;
                case 6:
                    this.exportMainInfo()
                    break;
                case 7:
                    this.exportLicenceInfo()
                    break;
                case 8:
                    this.exportApparatus()
                    break;
                case 15:
                    this.openFormDesign()
                    break;
                case 16:
                    if (this.returnData.list.length <= 0) {
                        this.$message({
                            message: "暂无数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.statusSendData.id = dataInfo['bgmId']
                    this.statusSendData.bgmRemarks = dataInfo['bgmRemarks'] //	备注
                    this.statusSendData.bgmActivestatus = dataInfo['activestatus'] //	商品状态

                    this.statusFlag = true;
                    break;
                case 17://锁定
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    this.lockSendDate.bgmId = dataInfo['bgmId']
                    this.lockSendDate.bgmRemarks = dataInfo['bgmRemarks']
                    this.lockSendDate.activestatus = 0
                    this.goodsLockState = true

                    break;
                case 18://解锁
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    this.lockSendDate.bgmId = dataInfo['bgmId']
                    this.lockSendDate.bgmRemarks = dataInfo['bgmRemarks']
                    this.lockSendDate.activestatus = 1
                    this.goodsLockState = true
                    break;
                case 19://DI维护
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    this.DIquery(dataInfo)
                    break;
                case 20://维护编码
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    for (const key in this.bgmCodeObj) {
                        this.bgmCodeObj[key] = dataInfo[key]
                    }
                    this.bgmCodeShow = true
                    break;
                case 21://生成拆零品种
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    if (!dataInfo) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    this.$http.storeShelfGeneralSpBgm({ ids: [dataInfo.bgmId] }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                message: res.message,
                                type: "success",
                            });
                            this.getDataList()
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })

                    break;
                case 22: //新增其他
                    this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                        if (!(/(商品|器械)/g.test(v.jciName))) this.formDataList.push(v)
                    })
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: '',
                        orderId: '',
                        printSouce: '',
                        printJurId: '',
                        fatherType: true
                    }
                    this.showStatus = true
                    break;
                case 23: //维护SPD编码
                    this.maintainSPD()
                    break;
                case 24: //更新注册证
                    this.bgiRegistnoShow = true
                    this.bgiRegistnoObj = {
                        newRegistnoId: "",
                        newBgiRegistno: "",
                        oldRegistnoId: "",
                        oldBgiRegistno: "",
                    }
                    break;
            }
        },
        // 维护SPD编码
        maintainSPD() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];

            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$prompt('请输入SPD编码', '维护SPD编码', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S+/,
                inputErrorMessage: 'SPD编码不能为空'
            }).then(async ({ value }) => {
                const params = {
                    spdCode: value,
                    unitId: dataInfo.bgmId,
                    type: 1
                }
                const res = await this.$http.supplierupdateSpdCode(params)
                if (res.status == 200) {
                    this.$message.success(res.message)
                    this.getDataList()
                } else {
                    this.$message.error(res.message)
                }
            }).catch(() => { });
        },
        bgmCodeSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    const res = await this.$http.BusinessGoodbindGoodSpid({ bgmId: this.bgmCodeObj.bgmId, spId: this.bgmCodeObj.spId })
                    if (res.status == 200) {
                        this.$message({
                            message: res.message,
                            type: "success",
                        });
                        this.bgmCodeShow = false
                        this.getDataList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: "error",
                        });
                    }
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                }
            })
        },
        bgiRegistnoSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    const res = await this.$http.BusinessGoodupdateRegistno({
                        newRegistnoId: this.bgiRegistnoObj.newRegistnoId,
                        oldRegistnoId: this.bgiRegistnoObj.oldRegistnoId,
                    })
                    if (res.status == 200) {
                        this.$message({
                            message: `更新了${res.result}条数据`,
                            type: "success",
                        });
                        this.bgiRegistnoShow = false
                        this.getDataList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: "error",
                        });
                    }
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                }
            })
        },
        async DIquery(row) {
            this.DIlist = []
            this.bgmId = row.bgmId
            const res = await this.$http.queryGoodDi({ ids: [this.bgmId] })
            if (res.status == 200) {
                if (res.result.length > 0) {
                    this.DIlist = res.result
                } else {
                    this.DIlist = []
                }
            } else {
                this.DIlist = []
            }
            this.DIShow = true
        },
        DInative() {
            if (this.diCode == "") {
                return this.$message.error("请输入DI码！")
            }
            var str = this.diCode
            var arr = this.DIlist.filter(item => item.diCode == str)
            if (arr.length == 0) {
                this.DIlist.push({
                    bgmId: this.bgmId,
                    diCode: str,
                })
            } else {
                this.$message.error("DI码不能重复！")
            }
            this.diCode = ""
        },
        async onDI() {
            const res = await this.$http.addGoodDi(this.DIlist)
            if (res.status == 200) {
                this.$message.success(res.message)
                this.DIShow = false
            } else {
                this.$message.error(res.message)
            }
        },
        delDIClick(index) {
            this.DIlist.splice(index, 1)
        },
        //商品锁定解锁
        lockSendAction(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$http.productLock(this.lockSendDate).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                message: res.message,
                                type: "success",
                            });
                            this.goodsLockState = false
                            this.getDataList()
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                }
            })


        },
        // 导出商品资料数据
        exportMainInfo() {

            this.getRequestData.ormId = sessionStorage.getItem("ormId")
            window.location.href = this.requesUrl + `/GSPgoods/exportGoodsData${this.$common.getUrl(this.getRequestData)}`;
        },
        // 导出器械主信息
        exportApparatus() {
            this.getRequestData.ormId = sessionStorage.getItem("ormId")
            window.location.href = this.requesUrl + `/GSPgoods/exportQxGoodsData${this.$common.getUrl(this.getRequestData)}`;
        },
        // 导出商品证照资料数据
        exportLicenceInfo() {
            this.getRequestData.ormId = sessionStorage.getItem("ormId")
            window.location.href = this.requesUrl + `/GSPgoods/exportGoodLicenceData${this.$common.getUrl(this.getRequestData)}`;
        },
        sendDataAction(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$http.setBusinessGoodsStatus(this.statusSendData).then(res => {
                        if (res.status == 200) {
                            this.$refs[formName].resetFields()
                            this.statusFlag = false;
                            this.getDataList()
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                }
            })
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getBusinessGoods(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = this.$common.getIndex(responseData.result.list);
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 左侧菜单数据
        async getMenuData() {
            const params = { codeClassify: 0 }
            const res = await this.$http.getQueryCodeClassify(params)
            if (res.status == 200) {
                this.menuList = res.result || []
            } else {
                this.menuList = []
            }
            this.activeMenu = "all"
            this.$set(this.getRequestData, 'codeType', '')
        },
        // 左侧菜单切换
        handleMenuSelect(codeId) {
            this.activeMenu = String(codeId)
            if (codeId === 'all') {
                this.$set(this.getRequestData, 'codeType', '')
            } else {
                const menuItem = this.menuList.find(item => String(item.codeId) === String(codeId))
                if (!menuItem) return
                this.$set(this.getRequestData, 'codeType', menuItem.codeType)
            }
            this.getRequestData.page = 1
            this.getDataList()
        },

        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.bgmId],
                    };
                    let responseData = await this.$http.delBusinessGoods(delData);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                })
                .catch(() => { });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()

        },
        //结束时间改成最后时间
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1
                this.getRequestData.end = time
            }
        },
        widthChange() {
            var centerEl = document.querySelector(".page_content_center")
            if (!centerEl) return
            var leftEl = document.querySelector(".page_content_center .left")
            var leftWidth = leftEl ? leftEl.clientWidth : 0
            this.tableWidth = centerEl.clientWidth - leftWidth - 10
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
        this.imgUrl = this.$store.getters.getConfig.imgUrl;
        this.ormId = sessionStorage.getItem('ormId')
        this.isMenu = window.global_config.isLeftMenuBgm || false
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.widthChange()
        window.addEventListener('resize', this.widthChange);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { window.removeEventListener("resize", this.widthChange); }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.page_content_center {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.left {
    flex-shrink: 0;
    overflow-y: auto;
    overflow-x: hidden;
    width: 150px;
}

.el-menu-vertical-demo {
    width: 150px;
    border-right: none;
}

.right {
    flex: 1;
    min-width: 0;
    width: calc(100% - 160px);
}

.right-full {
    width: 100%;
}

::v-deep .el-menu-item {
    height: 36px;
    line-height: 36px;
}

#left {
    width: 320px;
    flex-shrink: 0;
    border: 1px solid #eee;
    border-top: none;
}

.li_left {
    height: 30px;
    border-bottom: 1px solid #eee;
}

>>> .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #409eff;
}

>>> .is-current {
    color: #fff;
}

>>> .el-radio-button__inner {
    /* padding: 2px 8px !important; */
    font-size: 12px !important;
}

>>> #left .el-form-item__content,
.el-form-item__label {
    line-height: 15px !important;
}

.close {
    display: inline-block;
    cursor: pointer;
    font-size: 18px;
}

.close:hover {
    color: #409eff;
}

.floor {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    line-height: 40px;
}

.bgmObj {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.bgmObj p {
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: 16px;
}

.bgmObj p span:nth-child(1) {
    margin-right: 5px;
    color: #000;
    font-weight: bold;
}

.bgmObj p span:nth-child(2) {
    color: red;
}
</style>